
(function () {

  'use strict';

  angular
    .module('specsguardApp')
    .service('Help', helpService);

  helpService.$inject = ['$resource', '$log'];

  function helpService ($resource, $log) {
    const helpResource = $resource('/api/app/help');
    let helpPromise;
    let helpTexts;

    function getHelp () {
      if (helpTexts) {
        return Promise.resolve(helpTexts);
      } else if (!helpPromise) {
        helpPromise = helpResource.get().$promise;
      }

      return helpPromise.then(function (res) {
        helpTexts = res;
        return Promise.resolve(helpTexts);
      });
    }

    function getHelpText (key) {
      if (!helpTexts) {
        $log.error('help has not been loaded');
      }
      let searchkey = '';
      if (key) {
        searchkey = key.toLowerCase();
        searchkey = searchkey.replace(/\s/g, '_');
      }
      return helpTexts[searchkey] || {
        h: 'Sorry',
        b: 'Geen hulp aanwezig voor: ' + searchkey
      };
    }

    function getAll () {
      return helpTexts;
    }

    return {
      getHelp: getHelp,
      getHelpText: getHelpText,
      getAll: getAll,
    };
  }

})();
